import { Component, EventEmitter, Input, OnInit, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';

@Component({
  selector: 'app-picker',
  templateUrl: './picker.component.html',
  styleUrls: ['./picker.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PickerComponent implements OnInit {
  @Input() model!: string;
  @Input() name!: string;
  @Input() placeholder!: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() myForm!: NgForm;
  @Input() choices!: any; // Use Enums
  @Input() selected = '';
  @Input() keyOutputField = true;
  @Input() emptyChoice = false;
  @Input() emptyModel!: any;
  @Output() modelChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
    // Set default value
    if (!this.model) {
      this.model = this.selected.toString();
      this.eventChange();
    }
  }

  eventChange(): void {
    this.modelChange.emit(this.model);
  }

}
